<template>
    <div>
        <main>
            <section class="mx-auto container mt-10 p-3 md:p-0">
                <img class="mx-auto" src="/assets/img/check.png" alt="">
                <h1 class="text-center mt-5 text-xl font-bold poppins">Solicitação de envio de endereço enviado com sucesso!</h1>
                <p class="text-base text-center mx-auto Arial mt-5 md:w-2/5">Agora é só aguardar o seu produto chegar no
                    endereço cadastrado, assim que preparamos o seu pedido para expedição você receberá um código de
                    rastreio no e-mail ou se preferir poderá acompanhar tudo por aqui.</p>
                <div class="vx-row flex items-center justify-center">
                    <div class="vx-col w-full lg:w-1/4">
                        <vs-button class="dados-btn hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full mx-auto h-16 Arial text-xl md:text-2xl my-5" @click="$router.push({name: 'inicio'})">
                            Voltar ao Início
                        </vs-button>
                    </div>
                </div>
            </section>
            <section class="container mx-auto mt-6">
                <hr class=" border-gray-400 w-3/4 mx-auto">
                <div class="md:flex md:mx-auto m-6 text-center md:mt-8 md:w-8/12">
                    <h3 class="text-2xl Arial font-bold">O que será entregue</h3>
                </div>
                <div class="md:flex flex-col md:flex-row  mx-auto justify-center">
                    <div class="md:w-4/12 mx-2">
                        <div class="flex md:mt-4 bg-white md:p-1 border-2 border-gray-400">
                            <div class="w-5/12 p-6 md:p-6">
                                <img src="@/assets/images/weentregas/box-logo-black.png" width="100%" alt="">
                            </div>
                            <div class="md:w-7/12 my-auto">
                                <h4 class="text-base md:text-lg font-bold text-gray-900 ">{{brinde.nome}}</h4>
                                <p class="text-sm text-gray-600 Arial">O prazo de entrega dependerá do seu endereço de entrega.</p>
                            </div>
                        </div>
                    </div>
                    <div class="md:w-5/12 mx-2 my-auto">
                        <div class=" flex mt-4 md:p-1">
                            <div class="md:w-2/12 px-6 mt-2">
                                <img src="@/assets/images/weentregas/brazil.png" width="100%" alt="">
                            </div>
                            <div class="w-10/12 my-auto">
                                <h4 class="text-base md:text-lg font-bold text-gray-900">Enviamos para todo Brasil</h4>
                                <p class="text-sm text-gray-600 Arial">São aceitos apenas endereços no território brasileiro, caso você resida em outro país é necessário que alguém de sua
                                    confiança receba o pacote e encaminhe à seu endereço Internacional, (custos por sua conta, neste caso).</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
    export default {
        name: "Ordem",
        props: ['brinde']
    }
</script>

<style scoped>

</style>